import { NgModule, Pipe, PipeTransform } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';

@Pipe({
  name: 'customDate',
  standalone: false
})

export class CustomDatePipe extends DatePipe implements PipeTransform {
  transform(value: any, args?: any): any {
    return super.transform(value, 'd MMM y HH:mm', '+0000');
  }
}

@Pipe({
  name: 'dateEs',
  standalone: false
})

export class CustomDatEs extends DatePipe implements PipeTransform {
  transform(value: any, args?: any): any {
    return super.transform(value, 'dd/MM/yyyy');
  }
}

@NgModule({
  declarations: [CustomDatePipe, CustomDatEs],
  exports: [
    CustomDatePipe, CustomDatEs
  ],
  imports: [
    CommonModule,
  ]
})
export class CustomPipesModule {
}
